module.exports = __webpack_public_path__ + "files/90ef3441688d7ab7397a52745165b4ad.png";


//////////////////
// WEBPACK FOOTER
// ./images/favicon/apple-touch-icon-60x60.png
// module id = 566
// module chunks = 60